<template>
  <div v-if="suspended">
    <Lock :color="lockIconColor" width="15" height="15" />
  </div>
  <a v-else :class="[classes.emptyPicks]" :disabled="disabled">
    <div :class="[classes.emptyPicksLabel]">
      <StyledText
        tag="span"
        name="market-name"
        :fontId="buttonStyle?.primaryFont"
      >
        {{ meta }}
      </StyledText>
      <div tag="span" :class="[classes.emptyPicksIcon]">
        <slot :color="primaryColor" />
      </div>
    </div>
  </a>
</template>

<script lang="ts">
import { createUseStyles } from "@fresh8/vue-jss/src";
import { injectBrand } from "@fresh8/ad-data-composition/src/brand";
import { defineComponent, computed } from "vue";
import StyledText from "../../../styled/Text.vue";
import Lock from "../../../icons/Lock.vue";

export default defineComponent({
  name: "IconButton",
  components: {
    StyledText,
    Lock
  },
  props: {
    meta: {
      type: String,
      required: false,
      default: ""
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    buttonId: {
      type: String,
      required: false,
      default: ""
    },
    suspended: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(props) {
    const { getFontStyle, getButtonStyle } = injectBrand();
    const buttonStyle = computed(() => {
      return getButtonStyle(props.buttonId as string);
    });
    const buttonEnabled = computed(() => !props.disabled);
    const styleComputed = computed(() => ({
      buttonStyle: buttonStyle.value,
      buttonEnabled: buttonEnabled.value,
      primaryColor: getFontStyle(buttonStyle.value?.primaryFont)?.color,
      secondaryColor: getFontStyle(buttonStyle.value?.secondaryFont)?.color,
      suspended: !props.suspended && "flex-start"
    }));

    const lockIconColor = computed(
      () => getFontStyle(buttonStyle.value?.primaryFont)?.color || "#000"
    );

    const classes = useStyles(styleComputed);

    const title = computed(() => props.meta);

    const primaryColor = computed(
      () => getFontStyle(buttonStyle.value?.primaryFont)?.color || "#000"
    );

    return {
      title,
      classes,
      buttonStyle,
      buttonEnabled,
      lockIconColor,
      testClassName: computed(() => "text-style-market-name"),
      primaryColor
    };
  }
});

const defaultStyling = {
  backgroundColor: "#fff",
  borderRadius: "",
  borderColor: "",
  borderStyle: "",
  borderWidth: "",
  autoInteractions: true
};

const useStyles = createUseStyles({
  emptyPicks: {
    flex: "1",
    height: "32px",
    display: "flex",
    justifyContent: "center",
    borderRadius: props =>
      props.buttonStyle.borderRadius || defaultStyling.borderRadius,
    backgroundColor: props =>
      props.buttonStyle.backgroundColor || defaultStyling.backgroundColor,
    borderWidth: props =>
      props.buttonStyle.borderWidth || defaultStyling.borderWidth,
    borderStyle: props =>
      props.buttonStyle.borderStyle || defaultStyling.borderStyle,
    borderColor: props =>
      props.buttonStyle.borderColor || defaultStyling.borderColor,
    fontSize: "10px",
    lineHeight: "11px",
    alignItems: "center",
    textAlign: "center"
  },
  emptyPicksLabel: {
    fontSize: "10px",
    lineHeight: "11px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "4px"
  },
  emptyPicksIcon: {
    marginLeft: "8px"
  }
});
</script>
